<template>
  <div v-if="element" :class="`${element.compData.type}-theme-${element.compData.styleId}`" :style="{...getStyles({...element.compData.styles, wrapWidth: element.boxStyle.width, wrapHeight: element.boxStyle.height})}">
    <!-- <i-switch v-model="element.compData.status" :true-color="element.compData.styles.trueColor" :false-color="element.compData.styles.falseColor" @click.native="handleClick($event, element)">
      <span class="open" slot="open">{{element.compData.openText}}</span>
      <span class="close" slot="close">{{element.compData.closeText}}</span>
    </i-switch> -->
    <i-switch v-if="!element.compData.defaultSwitch" v-model="element.compData.status" :true-color="element.compData.styles.trueColor" :false-color="element.compData.styles.falseColor" @click.native="handleClick($event, element)">
      <span class="open" slot="open">{{element.compData.openText}}</span>
      <span class="close" slot="close">{{element.compData.closeText}}</span>
    </i-switch>
    <div v-else class="switch-icon">
      <img :src="element.compData.status ? (isAbsoluteUrl(element.compData.switchIcon['open']) ? element.compData.switchIcon['open'] : handleRepairePublicPrefix(element.compData.switchIcon['open'])) : (isAbsoluteUrl(element.compData.switchIcon['close']) ? element.compData.switchIcon['close'] : handleRepairePublicPrefix(element.compData.switchIcon['close']))" @click="changeStatus($event)">
    </div>
  </div>
</template>

<script>
import { Switch } from "view-design";
import "view-design/dist/styles/iview.css";
import { handleRepairePublicPrefix } from '@/util'

export default {
  name: "CompOnOff",
  props: {
    element: {
      type: Object,
      default: null,
      require: true,
    },
  },
  components: {
    "i-switch": Switch,
  },
  data: () => {
    return {
      loading: true,
      handleRepairePublicPrefix
    };
  },
  computed: {
    plugin: function () {
      return this.$getPlugin(this.element.id);
    },
  },
  mounted() {
    setTimeout(() => {
      this.loading = false;
    }, 1234);
    this.$blueMap.trigger({
      nodeType: "plugin",
      pluginId: this.element.id,
      dataKey: "onmounted",
      eventData: {
        value: this.element.compData,
        data: this.plugin,
        event: null,
      },
    });
  },
  methods: {
    handleClick(ev) {
      ev.stopPropagation();
      this.triggerEventType();
    },
    triggerEventType() {
      if (
        this.element &&
        this.element.compData &&
        this.element.compData.status
      ) {
        this.$blueMap.trigger({
          nodeType: "plugin",
          pluginId: this.element.id,
          dataKey: "onOpen",
          eventData: {
            value: this.element.compData,
            data: this.plugin,
            event: null,
          },
        });
      } else {
        this.$blueMap.trigger({
          nodeType: "plugin",
          pluginId: this.element.id,
          dataKey: "onClose",
          eventData: {
            value: this.element.compData,
            data: this.plugin,
            event: null,
          },
        });
      }
    },
    getStyles(styles) {
      if (!styles) return;
      const res = {};
      Object.keys(styles).forEach((item) => {
        res[`--${item}`] =
          typeof styles[item] === "number" ? styles[item] + "px" : styles[item];
        // console.log(item)
      });
      return res;
    },
    isAbsoluteUrl(url){
      return /^[a-z][a-z0-9+.-]*:/.test(url)
    },
    changeStatus(ev) {
      ev.stopPropagation();
      this.element.compData.status = !this.element.compData.status;
      this.triggerEventType();
    }
  },
};
</script>


<style lang='less' scoped>
// .wrap {
//   width: 100%;
//   height: 100%;
// }
//开关组件样式开始
/deep/ .ivu-switch {
  width: 100%;
  height: 100%;
  color: var(--bgColor);
  border-radius: var(--wrapHeight);
}
/deep/ .ivu-switch-inner {
  position: relative;
  display: block;
  width: 100%;
  box-sizing: border-box;
  text-align: center;
  line-height: var(--wrapHeight);
  font-size: var(--FontSize);
  font-family: var(--fontFamily) !important;
  color: var(--FontColor);
  font-weight: bold;
  padding-left: var(--wrapHeight);
  padding-right: calc(var(--wrapHeight) / 3);
  left: 0;
}
/deep/ .ivu-switch-checked {
  border-color: var(--bgColor);
  background-color: var(--bgColor);
  .ivu-switch-inner {
    padding-right: var(--wrapHeight);
    padding-left: calc(var(--wrapHeight) / 3);
  }
}
/deep/ .ivu-switch:after {
  position: absolute;
  top: 2px;
  left: 2px;
  width: calc(var(--wrapHeight) - 4px);
  height: calc(var(--wrapHeight) - 6px);
  background-color: var(--btnBg);
  border-radius: var(--wrapHeight);
}
/deep/ .ivu-switch-checked:after {
  left: calc(var(--wrapWidth) - var(--wrapHeight));
  border-radius: var(--wrapHeight);
}
//开关组件样式结束
.cursor {
  cursor: move;
}
</style>
